<nb-layout>
  <nb-layout-column>
    <nb-card-body>
      <app-share-dam-list *ngIf="loaded" [shareSyncUid]="shareSyncUid" [h1]="title"/>
    </nb-card-body>
  </nb-layout-column>
</nb-layout>
